// ============================================================
// Departments API
// ============================================================

import client from './axios';

export const departmentsApi = {
  getAll: async (schoolId, params = {}) => {
    const response = await client.get('/departments/', {
      params: { school_id: schoolId, ...params },
    });
    return response.data;
  },

  getById: async (id, schoolId) => {
    const response = await client.get(`/departments/${id}`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  create: async (schoolId, payload) => {
    const response = await client.post(`/departments/?school_id=${schoolId}`, payload);
    return response.data;
  },

  update: async (id, schoolId, payload) => {
    const response = await client.put(`/departments/${id}?school_id=${schoolId}`, payload);
    return response.data;
  },

  delete: async (id, schoolId) => {
    const response = await client.delete(`/departments/${id}?school_id=${schoolId}`);
    return response.data;
  },
};
